"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const next12_app_controller_reducers_sagas_main_reducer_1 = require("@gcloud-npm/next12.app-controller.reducers-sagas.main-reducer");
const filePath = `ErrorBoundary-${process.env.NEXT_PUBLIC_PROJECT_ID}`;
const processName = "APP-CONTROLLER";
class ErrorBoundary extends react_1.Component {
    constructor(props) {
        super(props);
        this.checkIfScreenErrorAppear = () => {
            const existError = this.checkErrorCode();
            const isFrontApp = typeof window !== "undefined";
            if (existError && isFrontApp) {
                let href = "";
                let info = "";
                if (window && window.location && window.location.href) {
                    href = window.location.href;
                }
                if (existError === 500) {
                    info = `Error ${existError} al montaje de página: ${href}`;
                }
                if (existError === 404) {
                    info = `Se intentó acceder a una página que no existe ${href}`;
                    if (document && document.referrer) {
                        info = `${info} pagina anterior: ${document.referrer}`;
                    }
                }
                this.runThrowSonda({ info });
            }
        };
        this.checkFullPagePrint = () => {
            // interval to have printTimie
            this.fullPagePrint = setInterval(() => {
                let { fullPagePrint } = this;
                const { timing } = window.performance;
                if (fullPagePrint) {
                    const renderMs = timing.domComplete - timing.domLoading;
                    const resultTime = Math.round(renderMs / 100) / 10;
                    if (resultTime && resultTime > 0) {
                        // it means we kille interval
                        console.log(`PAGE MOUNTED: ${resultTime}`);
                        clearInterval(fullPagePrint);
                        fullPagePrint = resultTime;
                        // intento dejar bien asociado el window.error
                        this.bindThrowSonda();
                        this.checkIfScreenErrorAppear();
                    }
                }
            }, 1000);
        };
        this.runThrowSonda = ({ info }) => {
            const { throwSonda } = this.props;
            throwSonda({
                kind: next12_app_controller_reducers_sagas_main_reducer_1.SONDA_KIND.FATAL,
                processName,
                filePath,
                info,
            });
        };
        this.bindThrowSonda = () => {
            window.addEventListener("error", (e) => {
                const { source, error } = e;
                const { throwSonda } = this.props;
                throwSonda({
                    kind: next12_app_controller_reducers_sagas_main_reducer_1.SONDA_KIND.ERROR,
                    processName,
                    filePath: source || filePath,
                    error,
                });
            });
        };
        this.checkErrorCode = () => {
            let res = 0;
            const is500 = !!document.querySelector('[cy-data="500"]') || false;
            const is400 = !!document.querySelector('[cy-data="404"]') || false;
            if (is500) {
                res = 500;
            }
            if (is400) {
                res = 404;
            }
            return res;
        };
        // Define a state variable to track whether is an error or not
        this.state = { hasError: false };
    }
    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI
        const { throwSonda } = this.props;
        throwSonda({
            kind: next12_app_controller_reducers_sagas_main_reducer_1.SONDA_KIND.FATAL,
            processName,
            filePath,
            error,
        });
        return { hasError: true };
    }
    componentDidMount() {
        this.checkFullPagePrint();
    }
    componentDidUpdate() {
        this.checkIfScreenErrorAppear();
    }
    componentDidCatch(error, errorInfo) {
        const { throwSonda } = this.props;
        throwSonda({
            kind: next12_app_controller_reducers_sagas_main_reducer_1.SONDA_KIND.FATAL,
            processName,
            filePath,
            error,
            info: `${errorInfo.toString()}`,
        });
        this.setState({
            hasError: true,
        });
    }
    render() {
        const { screen: Screen } = this.props;
        // Check if the error is thrown
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return react_1.default.createElement(Screen, null);
        }
        // Return children components in case of no error
        return this.props.children;
    }
}
// const mapStateToProps = (state) => ({
// });
const mapDispatchToProps = (dispatch) => ({
    throwSonda: (data) => dispatch(next12_app_controller_reducers_sagas_main_reducer_1.actions.throwSonda(data)),
});
exports.default = (0, react_redux_1.connect)(null, mapDispatchToProps)(ErrorBoundary);
//# sourceMappingURL=index.js.map